export const MIN_PASSWORD_LENGTH = 8;

export type PasswordPolicyResult = {
  ok: boolean;
  message: string | null;
};

const HAS_LETTER = /\p{L}/u;
const HAS_DIGIT = /\p{N}/u;

export function validatePassword(password: string): PasswordPolicyResult {
  if (!password) {
    return { ok: false, message: "Digite uma senha." };
  }

  if (password.length < MIN_PASSWORD_LENGTH) {
    return {
      ok: false,
      message: `A senha precisa ter pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`,
    };
  }

  if (!HAS_LETTER.test(password) || !HAS_DIGIT.test(password)) {
    return {
      ok: false,
      message: "A senha precisa ter pelo menos uma letra e um número.",
    };
  }

  return { ok: true, message: null };
}

export const PASSWORD_HINT = `Mínimo ${MIN_PASSWORD_LENGTH} caracteres, com letra e número`;
